import React, { useState } from "react";
import "./LocationCount.css";
import _ from "lodash";

export default function LocationCount(props) {

  const [matchup] = useState(props.matchup);
  const [locationCount] = useState(props.locationCount);

  const teamName = (id) => {
    let name = '--';
    if (id && matchup && matchup.teamData) {
      name = matchup.teamData.find(x => +x.id === +id) ? matchup.teamData.find(x => +x.id === +id).name : '--';
    }
    return name;
  }

  const locationName = (id) => {
    let name = '';
    if (id && matchup && matchup.locationFields) {
      name = matchup.locationFields.find(x => +x.id === +id) ? matchup.locationFields.find(x => +x.id === +id).title : '';
    }
    return name;
  }

  return (
    <>
      <div className="count-wrapper">
        <h2>Location Count</h2>
        {
          locationCount &&
          !_.isEmpty(locationCount) &&
          Object.keys(locationCount).map((k, i) => (
            <div className="time-blk" key={`${k}-${i}`}>
              <h3>{teamName(k)}</h3>
              <ul>
                {
                  Object.keys(locationCount[k]).map((key, index) => (
                    <li key={index}>{locationName(key)} - {locationCount[k][key]}</li>
                  ))
                }
              </ul>
            </div>
          ))
        }
      </div>
    </>
  );
}